import React from 'react';
import { ENTITY_CONSTANTS } from '../../../common/constants/entityConstants';
import { FORM_WIDGET_COMPONENTS } from '../../../common/form/formConstants';
import { FormContainer } from '../../../common/form/FormContainer';
import FormItem from '../../../common/form/FormItem';
import FormPanel from '../../../common/form/FormPanel';
import FormWidget from '../../../common/form/FormWidget';
import { useMutationWithContext } from '../../../common/hooks/useMutationWithContext';
import I18n from '../../../common/i18n/I18n';
import { autoCreateQuery, client } from '../../../organization/organization';
import OrganizationOptionRenderer from '../../../organization/OrganizationOptionRenderer';
import { getOption, quickAddOrganization } from '../../../organization/QuickAddOrganization';
import { jobTypes } from '../../mockData';

export default () => {
    const [save] = useMutationWithContext(autoCreateQuery, client);

    return (
        <FormPanel>
            <FormContainer>
                <FormItem half>
                    <FormWidget
                        name={`organizationReference`}
                        label={<I18n token="person.experiences.organization" />}
                        component={FORM_WIDGET_COMPONENTS.referenceAutocomplete}
                        entity={ENTITY_CONSTANTS.organization}
                        OptionRenderer={OrganizationOptionRenderer}
                        getOption={getOption}
                        addOption
                        onCreateHandle={quickAddOrganization}
                        saveMutation={save}
                        filter={{
                            expressions: [{ field: 'inactive', value: { values: ['false'] } }]
                        }}
                        testId={'professionalExperienceOrganization'}
                    />
                </FormItem>
                <FormItem half>
                    <FormWidget
                        name={`jobType`}
                        label={<I18n token="person.experiences.job.type" />}
                        component="MetadataAutocomplete"
                        optionValues={jobTypes}
                    />
                </FormItem>
                <FormItem half>
                    <FormWidget
                        name={`title`}
                        label={<I18n token="person.experiences.form.title" />}
                        component="MetadataAutocomplete"
                        metadataName="Title"
                        allowCreate
                        testId={'professionalExperienceTitle'}
                    />
                </FormItem>
                <FormItem half>
                    <FormWidget
                        name={`department`}
                        label={<I18n token="person.experiences.department" />}
                        component="MetadataAutocomplete"
                        metadataName="Department"
                        allowCreate
                        testId={'professionalExperienceDepartment'}
                    />
                </FormItem>
                <FormItem half>
                    <FormWidget
                        name={`professionalRoles`}
                        label={<I18n token="person.experiences.roles" />}
                        multiple
                        component="MetadataAutocomplete"
                        metadataName="ProfessionalRole"
                        identifier="termset"
                        testId={'professionalExperienceRoles'}
                    />
                </FormItem>
                <FormItem half>
                    <FormWidget
                        name={`location`}
                        label={<I18n token="person.experiences.location" />}
                        component="Location"
                    />
                </FormItem>
                <FormItem half>
                    <FormWidget
                        name={`dateRange.start`}
                        label={<I18n token="person.experiences.start.date" />}
                        component="Date"
                    />
                </FormItem>
                <FormItem half>
                    <FormWidget
                        name={`dateRange.end`}
                        label={<I18n token="person.experiences.end.date" />}
                        component="Date"
                    />
                </FormItem>
                <FormItem half>
                    <FormWidget
                        name={`keyExperience`}
                        label={<I18n token="person.experiences.key.experiences" />}
                        component="Switch"
                    />
                </FormItem>
            </FormContainer>
        </FormPanel>
    );
};
